// live:
const PLAYER_1_ENDPOINT = 'wss://play.livescape.tv:9002';
const PLAYER_2_ENDPOINT = 'wss://play.livescape.tv:9003';

// testing:
// const PLAYER_1_ENDPOINT = 'wss://localhost:9002';
// const PLAYER_2_ENDPOINT = 'wss://localhost:9003';

const MirrorConnection = {
  _socket: null,
  connected: false,
  connecting: false,
  connect: (playerNum) => { 
    console.log(`MirrorConnection: connect() was called.`);
    MirrorConnection.connecting = true;
    if (MirrorConnection._socket) {
        MirrorConnection._socket.disconnect();
        MirrorConnection._socket = null;
    }
    if (playerNum == '1') {
      MirrorConnection._socket = new WebSocket(PLAYER_1_ENDPOINT);
    }
    if (playerNum == '2') {
      MirrorConnection._socket = new WebSocket(PLAYER_2_ENDPOINT);
    }
    console.log('MirrorConnection._socket', MirrorConnection._socket)
  }
}
export default MirrorConnection;
